import React from "react";

class ErrorState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: "none",
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({ show: props.show });
  };

  componentWillMount = () => {
    this.setState({ show: this.props.show });
  };

  render() {
    return (
      <div
        className="row"
        style={{
          marginTop: "0px",
          textAlign: "center",
          fontSize: "12px",
          display: this.state.show,
          paddingLeft: "0px",
          color: "red",
        }}
      >
        {this.props.name && <p>Error: {this.props.name}</p>}
      </div>
    );
  }
}

export default ErrorState;
